import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pages/MenuPageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingSpinner"] */ "/vercel/path0/src/components/status/LoadingSpinner.tsx");
